import getCurrentCategory from './getCurrentCategory';
import { getStore } from '../store/store';
import { computed } from 'mobx';
var currentSubcategory = computed(function () {
    var currentCategory = getCurrentCategory();
    for (var subcategoryIndex = 0; currentCategory && subcategoryIndex < currentCategory.subcategories.length; subcategoryIndex++) {
        var currentSubcategory_1 = currentCategory.subcategories[subcategoryIndex];
        if (currentSubcategory_1.key === getStore().currentSubCategoryKey) {
            return currentSubcategory_1;
        }
    }
    return {};
});
export default (function () { return currentSubcategory.get(); });
//# sourceMappingURL=getCurrentSubcategory.js.map